class formaterService {
  static date(date) {
    return date ? new Date(date).toLocaleDateString('pt-BR') : null;
  }

  static time(date) {
    return date ? new Date(date).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : null;
  }

  static dateTime(date) {
    var data = this.date(date);
    var hora = this.time(date);
    return data && hora ? data + ' - ' + hora : null;
  }

  static currency(value) {
    return value ? parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : null;
  }

  static payment(value) {
    switch (value) {
      case 'onaccount':
        return 'Conta';
      case 'cash':
        return 'Dinheiro';
      case 'pix':
        return 'Pix';
      case 'card':
        return 'Cartão de Crédito';
      default:
        return value;
    }
  }

  static operationType(value) {
    switch (value) {
      case 'sell':
        return 'Venda';
      case 'descart':
        return 'Descarte';
      case 'replace':
        return 'Reposição';
      default:
        return value;
    }
  }
}

export default formaterService;